/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

export const tProductKind = t.keyof({
  gear: null,
  'pre-roll': null,
  extract: null,
  edible: null,
  merch: null,
  grow: null,
  tincture: null,
  flower: null,
  topical: null,
  vape: null,
});

export const tProductWeight = t.keyof({
  half_gram: null,
  gram: null,
  two_gram: null,
  eighth_ounce: null,
  quarter_ounce: null,
  half_ounce: null,
  ounce: null,
});
